module.exports = __webpack_public_path__ + "img/bg_avatar_female_84.f5dcad44.png";